































































import { Component, Vue } from "vue-property-decorator";

import FlexibleContentArea from "@/components/layout/FlexibleContentArea.vue";
import GlobalFooterLink from "@/components/layout/GlobalFooterLink.vue";
import GlobalFooterSnsLink from "@/components/layout/GlobalFooterSnsLink.vue";
import { OTHER_INFO } from "@/consts/const";
import { RouteName } from "@/consts/route";
import { ViewUtil } from "@/utils/view.util";
import dayjs from "dayjs";

@Component({
  components: { GlobalFooterSnsLink, GlobalFooterLink, FlexibleContentArea },
})
export default class GlobalFooter extends Vue {
  private OTHER_INFO = OTHER_INFO;

  private onClickPolicy(): void {
    this.$router.push({ name: RouteName.NotificationPolicy });
    window.scrollTo(0, 0);
  }

  private onOpen(url: string): void {
    ViewUtil.openInOtherTab(url);
  }

  get currentYearInYourTimeZone(): string {
    return dayjs().format("YYYY");
  }
}
